// @flow
import React, { useContext } from 'react'
// import Calendar from 'live/components/time/ui/calendar/index'
import Calendar from './index'

import MaskedInput from 'react-maskedinput'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import { SpanPickerContext } from '../utils/initialStates'
import { getMinSpans } from '../utils/RefreshFunctions'

type Props = {
    startDate: Object
    endDate: Object
    startTime: Object
    endTime: Object
    selectedSpanType: String
    selectDate: Function
    onChangeStartDate: Function
    onChangeStartTime: Function
    onChangeEndDate: Function
    onChangeEndTime: Function
    startDateString: String
    endDateString: String
    startDateError: Boolean
    endDateError: Boolean
    startTimeError: Boolean
    endTimeError: Boolean
    setDateFromSpan: Function
}

const CustomCalendar = (props: Props) => {
    const {
        startDate,
        endDate,
        startTime,
        endTime,
        selectedSpanType,
        selectDate,
        onChangeStartDate,
        onChangeStartTime,
        onChangeEndDate,
        onChangeEndTime,
        startDateString,
        endDateString,
        startDateError,
        endDateError,
        startTimeError,
        endTimeError,
        setDateFromSpan
    } = props
    const { formattedTree, operationsPickerConfigs } = useContext(SpanPickerContext)
    const minDate = operationsPickerConfigs.restrictDate ? +new Date(getMinSpans(formattedTree)) : undefined

    return (
        <div className="calendars-container">
            <CalendarWrapper className="calendar">
                <Calendar
                    timestamp={+new Date(Date.now())}
                    start={selectedSpanType === 'calendar' ? startDate : null}
                    end={selectedSpanType === 'calendar' ? endDate : null}
                    max={+new Date(Date.now())}
                    min={minDate}
                    onSelect={e => {
                        selectDate(e)
                    }}
                    fullMonth
                    showCalendar
                />
            </CalendarWrapper>
            <div  className="time-input-container-wrapper">
                <div className="time-input-container" onClick={setDateFromSpan}>
                    <label>{i18n('Start')} </label>
                    <MaskedInput
                        mask="1111-11-11"
                        type="text"
                        value={startDateString}
                        onChange={onChangeStartDate}
                        className={startDateError ? 'error' : ''}
                        placeholder={i18n('YYYY-MM-DD')}
                    />

                    <MaskedInput
                        mask="11:11"
                        type="text"
                        value={startTime}
                        onChange={onChangeStartTime}
                        className={startTimeError ? 'error' : ''}
                        placeholder="hh:mm"
                    />
                </div>

                <div className="to time-input-container" onClick={setDateFromSpan}>
                    <label className="to">to</label>
                </div>
                <div className="time-input-container borderLeft" onClick={setDateFromSpan}>
                    <label>{i18n('End')} </label>
                    <MaskedInput
                        mask="1111-11-11"
                        type="text"
                        value={endDateString}
                        onChange={onChangeEndDate}
                        className={endDateError ? 'error' : ''}
                        placeholder={i18n('YYYY-MM-DD')}
                    />
                    <MaskedInput
                        mask="11:11"
                        type="text"
                        value={endTime}
                        onChange={onChangeEndTime}
                        className={endTimeError ? 'error' : ''}
                        placeholder="hh:mm"
                    />
                </div>
            </div>
        </div>
    )
}

export default CustomCalendar

const calendarBlueMark = `
    background-color: rgb(166, 216, 249);
    position: absolute;
    z-index: -1;
    height: 24px;
    width: 24px;
    top: 0;
    content: '';
`

const calendarAbsoluteElement = `
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    width: 24px;
    line-height: 22px !important;
`

const CalendarWrapper = styled.div`
    .calendar-date {
        display: table;
        margin: auto;
        > table {
            font-family: ${({ theme }) => theme['font-regular']};
            font-size: 12px;
            text-align: center;
            color: #687186;
            padding: 4px 14px;
            > thead {
                > tr:first-child {
                    > th {
                        color: #bac2c7;
                        font-size: 12px;
                        &:not(.next):not(.prev) {
                            font-size: 16px;
                            font-weight: normal;
                            text-align: center;
                            color: #687186;
                            text-transform: capitalize;
                        }
                        &.prev {
                        }
                        &.next {
                            float: right;
                        }
                    }
                }
                > tr:not(:first-child) > th {
                    color: #7f8fa4;
                }
            }
            > tbody {
                border: 0px;
                > tr {
                    > td {
                        height: 24px !important;
                        width: 24px !important;
                        border: 0px;
                        color: #687186;
                        z-index: 3;
                        position: relative;
                        background: none;
                        padding: 0px;
                        &:hover {
                            background: none;
                        }
                        &.active,
                        &.active:hover {
                            color: #687186;
                        }
                        > span {
                            height: 0px;
                            width: 0px;
                            display: block;
                            z-index: 2 !important;
                            > span {
                                ${calendarAbsoluteElement}
                            }
                        }
                        &:not(.start-date):not(.end-date).in-range {
                            &:not(:last-of-type) > span {
                                ${calendarBlueMark}
                                background-color: transparent !important;
                                > span {
                                    background-color: transparent;
                                }
                                &::after {
                                    ${calendarBlueMark}
                                    border-radius: 0;
                                    left: 50%;
                                }

                                &::before {
                                    ${calendarBlueMark}
                                    border-radius: 50%;
                                    left: 3px;
                                }
                            }

                            &:last-of-type {
                                > span::before {
                                    ${calendarBlueMark}
                                    border-radius: 50%;
                                    left: 0%;
                                }
                                > span::after {
                                    ${calendarBlueMark}
                                    border-radius: 50%;
                                    left: 25%;
                                }
                            }
                            &:first-of-type {
                                > span {
                                    ${calendarBlueMark}
                                    ::before {
                                        ${calendarBlueMark}
                                        border-radius: 50%;
                                        left: 3px;
                                    }
                                }
                            }
                        }

                        &.start-date,
                        &.end-date {
                            > span {
                                > span {
                                    background-color: #37a3ef;
                                    border-radius: 50%;
                                    border-color: #37a3ef;
                                    color: #fff;
                                    font-weight: 600;
                                    z-index: 2;
                                }
                            }
                        }
                        &.start-date.in-range:not(.end-date) > span::after {
                            ${calendarBlueMark}
                            left: 50%;
                        }
                        &.end-date.in-range:not(:first-of-type):not(.in-range:nth-child(2)) > span::before {
                            ${calendarBlueMark}
                            right: 38%;
                        }
                        &.disabled {
                            color: #bac2c7;
                        }
                    }
                }
            }
        }
    }
`
